import { Box, Button, Popper, styled } from '@mui/material';

export const StyledButton = styled(Button)<{ newStyle?: boolean }>`
  border-radius: ${props => props?.newStyle ? '4px' : '8px'};
  height: ${props => props?.newStyle ? '36px' : '40px'};
`;

export const StyledPopper = styled(Popper)`
  z-index: 9999;
  min-width: 100%;
  border-radius: 4px;
  margin-top: 8px !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const StyledBox = styled(Box)`
  position: relative;
`;